// extracted by mini-css-extract-plugin
module.exports = {"allAttachmentMessage":"DataForm_allAttachmentMessage__17WHN","dialogDropdown":"DataForm_dialogDropdown__uTINy"};